import { client } from '@/client';
// 脚本预览
export function getCodePreview(params) {
  return client.post('/api/exec_script_service/preview', params);
}

// 提交脚本
export function submitScript(params) {
  return client.post('/api/exec_script_service/create', params);
}

// 查询K8s列表
export function queryK8sList(params) {
  return client.post('/api/ops_hosts/hostsK8sQuery', params);
}

// 获取初始化变量
export function getScriptInitVariables(params) {
  return client.post('/api/exec_script_service/variable/init', params);
}
